import { createContext, useContext, useState, useEffect, ReactNode } from "react";

type NeumorphicTheme = "dark" | "light";

interface NeumorphicThemeContextType {
  theme: NeumorphicTheme;
  toggleTheme: () => void;
}

const NeumorphicThemeContext = createContext<NeumorphicThemeContextType | undefined>(undefined);

export const NeumorphicThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<NeumorphicTheme>("light");

  useEffect(() => {
    const saved = localStorage.getItem("neumorphic-theme") as NeumorphicTheme;
    if (saved) {
      setTheme(saved);
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("neumorphic-theme", newTheme);
  };

  return (
    <NeumorphicThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </NeumorphicThemeContext.Provider>
  );
};

export const useNeumorphicTheme = () => {
  const context = useContext(NeumorphicThemeContext);
  if (!context) {
    throw new Error("useNeumorphicTheme must be used within NeumorphicThemeProvider");
  }
  return context;
};
